import { CharacteristicsPosts } from './CharacteristicsPosts';

export type { TypeCharacteristicsPostsProps } from './types';
export default CharacteristicsPosts;
